import { render, staticRenderFns } from "./EstablishmentYearSettings.vue?vue&type=template&id=2031e174&"
import script from "./EstablishmentYearSettings.vue?vue&type=script&lang=js&"
export * from "./EstablishmentYearSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports